import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ApiService from '../services/api';

const Login: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    try {
      await ApiService.login({ username, password });
      navigate('/dashboard');
    } catch (err: any) {
      setError(err.message || 'Login failed. Please check your credentials.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 50%, #cbd5e1 100%)',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
    }}>
      {/* Header */}
      <div style={{
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
        padding: '16px 0',
        backdropFilter: 'blur(10px)'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 24px',
          display: 'flex',
          alignItems: 'center'
        }}>
          <div style={{
            fontSize: '20px',
            fontWeight: 600,
            color: '#1e293b',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <span style={{
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              fontWeight: 700
            }}>
              Domains.Land
            </span>
            <span style={{ color: '#94a3b8' }}>|</span>
            <span style={{ color: '#64748b' }}>WHOIS API</span>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1,
        padding: '40px 24px'
      }}>
        <div style={{
          width: '100%',
          maxWidth: '420px',
          backgroundColor: '#ffffff',
          borderRadius: '16px',
          boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
          border: '1px solid #e2e8f0',
          overflow: 'hidden'
        }}>
          {/* Card Header */}
          <div style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            padding: '32px 32px 24px 32px',
            textAlign: 'center'
          }}>
            <h1 style={{
              fontSize: '28px',
              fontWeight: 700,
              color: '#ffffff',
              margin: '0 0 8px 0',
              letterSpacing: '-0.5px',
              textShadow: '0 2px 4px rgba(0,0,0,0.3)'
            }}>
              Admin Login
            </h1>
            <p style={{
              fontSize: '16px',
              color: 'rgba(255, 255, 255, 0.9)',
              margin: 0,
              fontWeight: 400
            }}>
              Whois API Server Control Panel
            </p>
          </div>

          {/* Card Body */}
          <div style={{
            padding: '32px'
          }}>
          {error && (
            <div style={{
              backgroundColor: '#fff5f5',
              color: '#e03131',
                padding: '14px 16px',
                borderRadius: '8px',
              marginBottom: '24px',
              fontSize: '14px',
                border: '1px solid #ffc9c9',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
            }}>
                <span>⚠️</span>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '24px' }}>
              <label 
                htmlFor="username"
                style={{
                  display: 'block',
                  marginBottom: '8px',
                  fontSize: '14px',
                    fontWeight: 600,
                    color: '#495057'
                }}
              >
                Username
              </label>
              <input
                id="username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                style={{
                  width: '100%',
                    padding: '12px 16px',
                    fontSize: '15px',
                    border: '2px solid #e9ecef',
                    borderRadius: '8px',
                  outline: 'none',
                    transition: 'all 0.2s ease',
                    backgroundColor: '#ffffff',
                    boxSizing: 'border-box'
                }}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#667eea';
                    e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#e9ecef';
                    e.target.style.boxShadow = 'none';
                  }}
              />
            </div>

              <div style={{ marginBottom: '32px' }}>
              <label 
                htmlFor="password"
                style={{
                  display: 'block',
                  marginBottom: '8px',
                  fontSize: '14px',
                    fontWeight: 600,
                    color: '#495057'
                }}
              >
                Password
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                style={{
                  width: '100%',
                    padding: '12px 16px',
                    fontSize: '15px',
                    border: '2px solid #e9ecef',
                    borderRadius: '8px',
                  outline: 'none',
                    transition: 'all 0.2s ease',
                    backgroundColor: '#ffffff',
                    boxSizing: 'border-box'
                }}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#667eea';
                    e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#e9ecef';
                    e.target.style.boxShadow = 'none';
                  }}
              />
            </div>

            <button
              type="submit"
              disabled={isLoading}
              style={{
                width: '100%',
                  padding: '14px 20px',
                  background: isLoading 
                    ? 'linear-gradient(135deg, #adb5bd 0%, #6c757d 100%)'
                    : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: '#ffffff',
                border: 'none',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: 600,
                cursor: isLoading ? 'not-allowed' : 'pointer',
                  transition: 'all 0.2s ease',
                  boxShadow: isLoading 
                    ? 'none'
                    : '0 4px 12px rgba(102, 126, 234, 0.3)',
                  transform: isLoading ? 'none' : 'translateY(0)',
              }}
              onMouseOver={(e) => {
                  if (!isLoading) {
                    e.currentTarget.style.transform = 'translateY(-1px)';
                    e.currentTarget.style.boxShadow = '0 6px 16px rgba(102, 126, 234, 0.4)';
                  }
              }}
              onMouseOut={(e) => {
                  if (!isLoading) {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.3)';
                  }
              }}
            >
                {isLoading ? (
                  <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                    <span style={{
                      width: '16px',
                      height: '16px',
                      border: '2px solid transparent',
                      borderTop: '2px solid #ffffff',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite'
                    }}></span>
                    Signing in...
                  </span>
                ) : (
                  'Sign In'
                )}
            </button>
          </form>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div style={{
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        borderTop: '1px solid rgba(0, 0, 0, 0.1)',
        padding: '20px 0',
        textAlign: 'center',
        backdropFilter: 'blur(10px)'
      }}>
        <p style={{
          fontSize: '14px',
          color: '#64748b',
          margin: 0
        }}>
          © 2024 Domains.Land - WHOIS API Service
        </p>
      </div>

      {/* CSS Animation */}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default Login; 